'use client'

import React, { useEffect, useId, useState, useRef } from "react"
import { useSearchParams, usePathname, useRouter } from "next/navigation"
import { useDebounceCallback } from "usehooks-ts"
import Checkbox from "@/components/form/Checkbox"
import { changeFilters, convertSearchParamToArray, toggleFilter } from "@/services/search"
import Dropdown from "@/components/form/Dropdown"
import moment from 'moment'
import 'moment/locale/fr'
import { categories } from "@/services/school"
moment.locale('fr')

type FiltersProps = {
    aroeven: Aroeven
}

export default function Filters({
    aroeven
}: FiltersProps) {

    const searchParams = useSearchParams()
    const pathname = usePathname()
    const { replace } = useRouter()

    const changeFiltersWithDebounce = useDebounceCallback((filters: any) => {
        replace(`${pathname}?${changeFilters(searchParams, filters).toString()}`, {
            scroll: false
        })
    }, 300)

    console.log(searchParams.get('period'))

    return (
        <>
            <aside className="sidebar filtres bg-bloc y-gap-40">
                <div className="sidebar__item">
                    <h4 className="text-18 mb-20">Thématique</h4>
                    <div className="sidebar-checkbox">
                        {Object.entries(categories).map(([keyCategory, category], indexCategory) => {
                            const searchParam = 'categories'
                            return (
                                <React.Fragment key={'category-' + indexCategory}>
                                    <div className="d-flex items-center justify-content-between">
                                        <Checkbox
                                            defaultChecked={searchParams.get(searchParam)?.split(',').includes(keyCategory) ?? false}
                                            toggle={() => replace(`${pathname}?${toggleFilter(searchParams, searchParam, keyCategory).toString()}`, {
                                                scroll: false
                                            })}
                                            label={category.name}
                                        />
                                    </div>
                                </React.Fragment>
                            )
                        })}
                    </div>
                </div>
                <div className="sidebar__item">
                    <h4 className="text-18 mb-20">Période</h4>
                    <div className="sidebar-checkbox">
                        {Object.entries(Array.from({ length: 12 }, (_, i) => (((i + parseInt(moment().format('M')) - 1) % 12) + 1)).reduce((options, month) => {
                            return {
                                ...options,
                                [(month < parseInt(moment().format('M')) ? (parseInt(moment().format('YYYY'))) + 1 : moment().format('YYYY')) + '-' + moment(month, 'M').format('MM')]: moment(month, 'M').format('MMM') + ' ' + (month < parseInt(moment().format('M')) ? (parseInt(moment().format('YYYY'))) + 1 : moment().format('YYYY'))
                            }
                        }, {})).map(([keyPeriod, period], indexPeriod) => {
                            const searchParam = 'period'
                            return (
                                <React.Fragment key={'period-' + indexPeriod}>
                                    <div className="d-flex items-center justify-content-between">
                                        <Checkbox
                                            defaultChecked={searchParams.get(searchParam)?.split(',').includes(keyPeriod) ?? false}
                                            toggle={() => replace(`${pathname}?${toggleFilter(searchParams, searchParam, keyPeriod).toString()}`, {
                                                scroll: false
                                            })}
                                            label={period as string}
                                        />
                                    </div>
                                </React.Fragment>
                            )
                        })}

                    </div>
                </div>
                {/*<div className="sidebar-item">
                    <h4 className="text-18 mb-20">Période</h4>
                    <Dropdown
                        multiple={true}
                        search={false}
                        value={convertSearchParamToArray(searchParams['period'] ?? "")}
                        options={Array.from({ length: 12 }, (_, i) => (((i + parseInt(moment().format('M')) - 1) % 12) + 1)).reduce((options, month) => {
                            return {
                                ...options,
                                [moment(month, 'M').format('MM') + '-' + (month < parseInt(moment().format('M')) ? (parseInt(moment().format('YYYY'))) + 1 : moment().format('YYYY'))]: moment(month, 'M').format('MMM') + ' ' + (month < parseInt(moment().format('M')) ? (parseInt(moment().format('YYYY'))) + 1 : moment().format('YYYY'))
                            }
                        }, {})}
                        placeholder="Toutes les périodes"
                        onChange={(value) => {
                            console.log(value)
                            if (!value) return
                            //if (value.length !== 2) return
                            const updatedSearchParams = changeFilters(searchParams, {
                                period: value
                            })
                            replace(`${pathname}?${updatedSearchParams.toString()}`, {
                                scroll: false
                            })                            
                        }}
                        withLabel={false}
                    />
                </div>*/}
                <div className="col-12 pb-0 pt-10">
                    {/*<a href="#" className="button-primary d-block w-100">
                        Filtrer les résultats
                    </a>*/}
                    <a href="#" onClick={(e) => {
                        e.preventDefault()
                        replace(`${pathname}`, {
                            scroll: false
                        })
                    }}>
                        <span className="info d-flex justify-content-center mt-10">
                            <i className="fi fi-ss-circle-xmark mr-5" />
                            Annuler tous les filtres
                        </span></a>
                </div>
            </aside >
        </>
    )
}